/**
 * 须在 bip39 之前加载：bip39 的 checksum 依赖 Buffer.from，浏览器需显式注入。
 */
import { Buffer } from 'buffer';

/* eslint-disable no-undef */
if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}
if (typeof globalThis !== 'undefined' && !globalThis.Buffer) {
  globalThis.Buffer = Buffer;
}
